import { cx } from "../../utils";

const Skeleton = ({ className = "", rounded = "rounded-md" }) => (
  <div
    className={cx(
      "bg-gradient-to-r from-ink-100 via-ink-200/60 to-ink-100 bg-[length:1000px_100%] animate-shimmer",
      rounded,
      className,
    )}
  />
);

export const SkeletonCard = () => (
  <div className="bg-white border border-ink-200/70 rounded-2xl shadow-card p-5">
    <div className="flex items-center gap-3">
      <Skeleton className="h-11 w-11" rounded="rounded-xl" />
      <div className="flex-1 space-y-2">
        <Skeleton className="h-3.5 w-1/2" />
        <Skeleton className="h-3 w-1/3" />
      </div>
    </div>
    <Skeleton className="h-3 w-full mt-5" />
    <Skeleton className="h-3 w-4/5 mt-2" />
    <div className="flex gap-2 mt-5">
      <Skeleton className="h-5 w-16" rounded="rounded-md" />
      <Skeleton className="h-5 w-20" rounded="rounded-md" />
    </div>
  </div>
);

export const SkeletonRow = () => (
  <div className="flex items-center gap-3 py-3">
    <Skeleton className="h-9 w-9" rounded="rounded-lg" />
    <div className="flex-1 space-y-2">
      <Skeleton className="h-3 w-1/3" />
      <Skeleton className="h-3 w-2/3" />
    </div>
    <Skeleton className="h-6 w-12" />
  </div>
);

export default Skeleton;
